var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigDislikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dislike-icon",
    transform: "translate(-9601 14317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 32,
    height: 32,
    transform: "translate(9601 -14317)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-thumb-up",
    "data-name": "Icon material-thumb-up",
    d: "M1.5,1.5H6.831V17.492H1.5ZM30.818,16.159a2.673,2.673,0,0,1-2.665,2.665H19.744l1.266,6.09.04.426a2.006,2.006,0,0,1-.586,1.413l-1.413,1.4-8.769-8.782A2.606,2.606,0,0,1,9.5,17.492V4.165A2.673,2.673,0,0,1,12.161,1.5H24.155a2.647,2.647,0,0,1,2.452,1.626l4.025,9.4a2.633,2.633,0,0,1,.187.973v2.545l-.013.013Z",
    transform: "translate(9600.5 -14313.5)",
    fill: "#d782a2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDislikeIcon);
export default __webpack_public_path__ + "static/media/big-dislike-icon.2d3b59b5.svg";
export { ForwardRef as ReactComponent };